<h1 ev-dialog-title>{{ languageService.languageJSON.TabbedInfoDialog_Feedback }}</h1>

<div ev-dialog-content #feedbackScrollbar class="scrollable" data-testid="feedback-container">
  <div class="feedback-content">

    <div [hidden]="!success()" class="ev-logo">
      <img [src]="'/assets/icons/' + settingsService.getMap().Skin + '/logo/ev_navigation_logo.png'" />
    </div>

    @if (!success()) {
      <app-modal-option-panel>
        <div class="modal-option-panel__stack">

          <div class="input-el">
            <label>Email</label>
            <input class="text-input" type="email" name="email" [(ngModel)]="email" email data-testid="feedback-email-input" />
          </div>
          <div class="error-text" [ngClass]="{ show: emailError() }">
            {{ languageService.languageJSON.Feedback_Email_Error }}
          </div>

          <div class="input-el">
            <label>{{ languageService.languageJSON.Feedback_Rating }}</label>
            <div class="rating-icons">
              @for (ratingId of ratingArr(); track ratingId; let i = $index) {
                <button type="button" class="rating-btn" (click)="rating.set(i + 1)" [attr.data-testid]="'feedback-rating-' + i + '-btn'">
                  <img class="star-btn"
                    src="assets/icons/default/ui/star.png"
                    [class.star-btn-selected]="showIcon(i)"
                    alt="rating" />
                </button>
              }
            </div>
          </div>
          <div class="error-text" [ngClass]="{ show: msgError() }">
            {{ languageService.languageJSON.Feedback_Rating_Missing }}
          </div>

          <div class="input-el">
            <label class="review-desc">{{ languageService.languageJSON.Feedback_Message_Title }}</label>
            <textarea class="text-input textarea" [(ngModel)]="reviewText" maxlength="65536" data-testid="feedback-message-input"></textarea>
          </div>
          <div class="error-text" [ngClass]="{ show: msgError() }">
            {{ languageService.languageJSON.Feedback_Rating_Missing }}
          </div>

          <div class="input-el">
            <mat-checkbox [(ngModel)]="allowSensitiveData" data-testid="feedback-sensitive-data-checkbox">
              {{ languageService.languageJSON.Feedback_AllowSensitiveData }}
            </mat-checkbox>
          </div>

          <p class="privacy-el">
            <a (click)="openPrivacyPolicy()" data-testid="feedback-privacy-policy-link">{{ languageService.languageJSON.Feedback_OpenPrivacyPolicy }}</a> |
            <a (click)="openEUDataActPolicy()" data-testid="feedback-eu-data-act-link">{{ languageService.languageJSON.TabbedInfoDialog_EUDataActPolicy }}</a>
          </p>
          @if (webView()) {
            <p class="privacy-el">
              <a (click)="openEula()" data-testid="feedback-eula-link">{{ languageService.languageJSON.Feedback_OpenEula }}</a>
            </p>
          }

          @if (!success() && !failed() && !sending()) {
            <div class="recaptcha-outer">
              <app-recaptcha [siteKey]="siteKey" (resolved)="resolved($event)" data-testid="feedback-recaptcha" />
            </div>
          }

          <div class="error-text" [ngClass]="{ show: recaptchaError() }">
            {{ languageService.languageJSON.Feedback_Recaptcha }}
          </div>
        </div>
      </app-modal-option-panel>
    }

    <h3 [hidden]="!sending()" class="status-text">{{ languageService.languageJSON.Feedback_Email_Sending }}...</h3>
    <h3 [hidden]="!failed()" class="status-text">{{ languageService.languageJSON.Feedback_Email_Failed }}</h3>
    <h3 [hidden]="!success()" class="status-text success">
      <span class="check-icon">
        <img alt="checked" src="assets/icons/default/ui/check.svg" />
      </span>
      {{ languageService.languageJSON.Feedback_Email_Success }}
    </h3>

  </div>
</div>

<div ev-dialog-actions>
  @if (!success()) {
    <button class="ev-button primary" name="ok_button" mat-button (click)="accept()" data-testid="feedback-send-btn">
      {{ languageService.languageJSON.Global_Send }}
    </button>
  }
  @if (success()) {
    <button class="ev-button primary" name="ok_button" mat-button (click)="resetform()" data-testid="feedback-new-btn">
      {{ languageService.languageJSON.Feedback_NewFeedback }}
    </button>
  }
  <button class="ev-button" name="cancel_button" mat-button (click)="dialogRef?.close()" data-testid="feedback-close-btn">
    {{ languageService.languageJSON.Global_Close }}
  </button>
</div>
